import { TicketSessions } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<TicketSessions>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const ticketsReducer = createReducer<State, Actions>(initialState, {
  [actions.getEventTickets.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getEventTickets.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getEventTickets.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getEventTickets.reset.type]: actionsHandlers.handleGetManyReset,
});

export default ticketsReducer;
